import  * as React from "react";
import { observer } from "mobx-react";
import SingleTileStyle from "./single-tile.module.scss";
import {ISingleTileProps} from "./ISingleTileProps";

@observer
export class SingleTile extends React.Component<ISingleTileProps>{
    constructor(props: ISingleTileProps) {
        super(props, undefined);
        this.handleClick = this.handleClick.bind(this);
        
    }

    handleClick() {
        this.props.setAdditionalInfoUrl && this.props.setAdditionalInfoUrl(this.props.infoPage);
    }

    render() {
        return <div data-toggle="modal" className={this.props.className}
                    style={{ borderColor: this.props.color, cursor: (this.props.infoPage && (this.props.isWeb || this.props.isIos)) ? 'pointer' : 'default' }}
                    data-target={ (this.props.infoPage && this.props.enableInfoModal && (this.props.isWeb || this.props.isIos)) ? "#showAdditionalInfoOnTile" : ""}
                    onClick={this.handleClick}>
                   {(!this.props.isEmpty) &&
                <span className={SingleTileStyle.parameterName} style={{ color: this.props.color }}>{this.props.title}</span>
                   }
            {this.props.isEmpty && <span className={SingleTileStyle.parameterNameEmpty}></span> }
            <span className={SingleTileStyle.parameterLine}></span>
                   <span className={SingleTileStyle.parameterValue}> { this.props.value } </span>
                   <span className={SingleTileStyle.parameterUnit}> { this.props.unit } </span>
               </div>;
    }
}
